export default __webpack_public_path__ + "static/featureCards_completeControl-cf0661863048534f7d8e18f08b445677.mp4";